import { environment } from "../../../environments/environment";

export const appSessionManagerConstants = {
  events: {
    signalR: {
      disconnect: "SessionManagerDisconnectUser",
      message: "SessionManagerSendMessageToUser"
    }
  },
  url: {
    disconnectUser: environment.appSettings.apiBaseAddress + '/Signalr/SessionManager/DisconnectUser',  // LASCIARE /Signalr/SessionManager/...
    getConnectedClients: environment.appSettings.apiBaseAddress + '/Signalr/SessionManager/GetConnectedClients',  // LASCIARE /Signalr/SessionManager/...
    sendMessageToUser: environment.appSettings.apiBaseAddress + '/Signalr/SessionManager/SendMessageToUser' // LASCIARE /Signalr/SessionManager/...
  }
};
